document.addEventListener('turbo:load', function () {
  console.log('Hello from post-show.js!');

  const likeCounters = document.querySelectorAll('.like-counter');

  likeCounters.forEach((counter) => {
    const likeButton = counter.querySelector('button');
    const likeCountElement = counter.querySelector('span');

    likeButton.addEventListener('click', () => {
      const postId = likeButton.dataset.postId;
      const likeId = likeButton.dataset.likeId; // The ID of the like (if it exists)
      const liked = likeButton.dataset.liked === 'true';

      const url = `/posts/${postId}/likes${liked ? `/${likeId}` : ''}`;
      const method = liked ? 'DELETE' : 'POST';

      fetch(url, {
        method: method,
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content,
        },
      })
        .then((response) => {
          if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
          return response.json();
        })
        .then((data) => {
          likeCountElement.textContent = data.like_count; // Update the like count
          likeButton.dataset.liked = data.liked; // Toggle liked state
          likeButton.dataset.likeId = data.like_id; // Update like ID (if liked)
          likeButton.innerHTML = `<i class="fa-solid ${data.liked ? 'fa-heart text-danger' : 'fa-heart'}"></i>`;
        })
        .catch((error) => {
          console.error('Error updating like status:', error);
        });
    });
  });

  const supportButton = document.getElementById('support-pay-button');
  const supportModal = document.getElementById('supportModal');
  const loginModal = document.getElementById('login-modal');
  const guestPurchase = document.getElementById('guest-purchase');
  const closeButton = document.querySelector('.close-modal-button'); // Ensure this exists
  const form = document.getElementById('payment-form');
  const errorElement = document.getElementById('card-errors');
  const submitButton = document.getElementById('submitPaymentButton');
  const paymentEmailInput = document.getElementById('paymentEmail');
  const starCountField = document.getElementById('star-count-field');
  const customStarCountField = document.querySelector('.custom-star-count');
  const amountField = document.getElementById('amount-field');
  const supportTrigger = document.getElementById('support-trigger');
  var userSignedInElement = document.getElementById('user-signed-in');
  var userSignedIn = userSignedInElement.value === 'true';
  const postContainer = document.getElementById('post-container');
  const postSlug = postContainer.dataset.postSlug;

  //   console.log('User signed in:', userSignedIn);
  //   console.log('Support button:', supportButton);
  //   console.log('Support trigger:', supportTrigger);
  //   console.log('Support modal:', supportModal);
  //   console.log('Post Container:', postContainer);
  //   console.log('Post slug:', postSlug);

  if (supportButton) {
    console.log('Support button found on this page.');
    // Handle Support Button Click
    supportButton.addEventListener('click', function (event) {
      event.preventDefault();
      const starCount = parseInt(document.getElementById('star-count-field').value, 10);
      const supporterMessage = document.getElementById('supporter-message').value;
      const supporterName = document.getElementById('supporter-name').value;
      console.log('Supporter Message:', supporterMessage);
      console.log('Supporter Name:', supporterName);

      updateSupportAmount(starCount);
    });
  }

  if (supportTrigger) {
    console.log('Support trigger found on this page.');
    supportTrigger.addEventListener('click', function (event) {
      event.preventDefault();
      console.log('Support trigger clicked');
      var loginModal = document.getElementById('login-modal');
      var closeButton = document.getElementsByClassName('close')[0];
      var closeButton2 = document.getElementsByClassName('close-button')[0];
      var guestPurchase = document.getElementById('guest-purchase');

      if (userSignedIn) {
        console.log('User is signed in');
        // User is signed in, show the normal support modal
        supportModal.style.display = 'block';

        // When the user clicks on <span> (x), close the modal
        if (closeButton) {
          closeButton.onclick = function () {
            supportModal.style.display = 'none';
          };
        }
      } else {
        console.log('User is not signed in');
        // User is not signed in, show the login modal
        loginModal.style.display = 'block';

        guestPurchase.onclick = function () {
          // Handle guest purchase logic here
          console.log('Guest purchase clicked');
          loginModal.style.display = 'none';
          if (supportModal) {
            supportModal.style.display = 'block';
          }
        };
      }
    });
  }

  const stripePublicKey = supportTrigger.getAttribute('data-stripe-public-key');
  const stripe = Stripe(stripePublicKey, {
    betas: ['link_beta_1'],
  });

  // Initialize Stripe Elements
  const elements = stripe.elements();
  const card = elements.create('card', {
    style: {
      base: {
        fontSize: '16px',
        color: '#32325d',
      },
    },
  });
  card.mount('#card-element');

  // Handle Modal Close
  const closeModal = () => {
    supportModal.style.display = 'none';
    loginModal.style.display = 'none';
  };

  // Event Listener for Close Button
  if (closeButton) {
    closeButton.addEventListener('click', closeModal);
  }

  // Close modal when clicking outside
  window.addEventListener('click', function (event) {
    if (event.target == supportModal) {
      closeModal();
    }
    if (event.target == loginModal) {
      loginModal.style.display = 'none';
    }
  });

  // Handle Guest Purchase Click
  guestPurchase.addEventListener('click', function (event) {
    event.preventDefault();
    loginModal.style.display = 'none';
    if (supportModal) {
      supportModal.style.display = 'block';
    }
  });

  // Handle Form Submission
  if (form) {
    form.addEventListener('submit', async function (event) {
      event.preventDefault();
      submitButton.disabled = true;

      const { paymentMethod, error } = await stripe.createPaymentMethod({
        type: 'card',
        card: card,
      });

      if (error) {
        errorElement.textContent = error.message;
        submitButton.disabled = false;
      } else {
        // Send paymentMethod.id to your server
        const payload = {
          payment_method_id: paymentMethod.id,
          charge_amount: amountField.value,
          artist_slug: document.getElementById('artistSlug').value,
          post_slug: postContainer.dataset.postSlug, // Ensure this ID exists
          receipt_email: paymentEmailInput.value,
          stars: starCountField.value,
          message: document.getElementById('supporter-message').value,
          supporter_name: document.getElementById('supporter-name').value,
          guest_email: paymentEmailInput.value,
        };

        try {
          console.log('Url:', `/artists/${payload.artist_slug}/create_payment`);
          console.log('post_slug:', payload.post_slug);
          const response = await fetch(`/artists/${payload.artist_slug}/create_payment`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'X-CSRF-Token': document.querySelector("[name='csrf-token']").content,
            },
            body: JSON.stringify(payload),
          });

          const result = await response.json();

          if (result.error) {
            errorElement.textContent = result.error;
            submitButton.disabled = false;
          } else {
            alert('Thank you for your support! Your payment has been successfully processed.');
            window.location.href = `/posts/${payload.post_slug}`;
          }
        } catch (err) {
          console.error('Error:', err);
          errorElement.textContent = 'An unexpected error occurred.';
          submitButton.disabled = false;
        }
      }
    });
  }

  // Real-time validation errors from the card Element
  card.on('change', function (event) {
    if (event.error) {
      errorElement.textContent = event.error.message;
    } else {
      errorElement.textContent = '';
    }
  });

  // Handle Star Button Clicks
  const starButtons = document.querySelectorAll('.star-btn');
  starButtons.forEach((button) => {
    button.addEventListener('click', function () {
      const starValue = parseInt(this.dataset.value, 10);
      updateSupportAmount(starValue);
    });
  });

  // Handle Custom Star Count Input
  if (customStarCountField) {
    customStarCountField.addEventListener('input', function () {
      const customStarValue = parseInt(this.value, 10) || 0;
      updateSupportAmount(customStarValue);
    });
  }

  // Function to Update Support Amount
  function updateSupportAmount(numberOfStars) {
    const baseStarCost = 5; // Cost per star
    const platformFeePercent = 5; // Platform fee percentage
    const stripeFeePercent = 2.9; // Stripe fee percentage
    const stripeFixedFee = 0.3; // Stripe fixed fee in dollars

    const initialCharge = numberOfStars * baseStarCost;
    const platformFee = initialCharge * (platformFeePercent / 100);
    const stripeFee = initialCharge * (stripeFeePercent / 100) + stripeFixedFee;
    const finalCharge = initialCharge + platformFee + stripeFee;

    const formattedCharge = finalCharge.toFixed(2);

    document.getElementById('base-charge-amount').textContent = `$${initialCharge.toFixed(2)}`;
    document.getElementById('platform-fee-amount').textContent = `$${platformFee.toFixed(2)}`;
    document.getElementById('stripe-fee-amount').textContent = `$${stripeFee.toFixed(2)}`;
    document.getElementById('total-charge-amount').textContent = `$${finalCharge.toFixed(2)}`;

    const supportButtonText = `Support $${initialCharge.toFixed(2)}`;
    const supportButton = document.getElementById('support-button');
    if (supportButton) {
      supportButton.textContent = supportButtonText;
    }

    const chargeAmountElement = document.getElementById('charge-amount');
    if (chargeAmountElement) {
      chargeAmountElement.textContent = `$${formattedCharge}`;
    }

    const visibleChargeAmountElement = document.getElementById('visible-charge-amount');
    if (visibleChargeAmountElement) {
      visibleChargeAmountElement.textContent = `$${formattedCharge}`;
    }

    const starCountFieldElement = document.getElementById('star-count-field');
    if (starCountFieldElement) {
      starCountFieldElement.value = numberOfStars;
    }
  }

  // Function to Validate Email
  function validateEmail(email) {
    const re = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
    return re.test(String(email).toLowerCase());
  }

  // Email Input Validation
  const emailInput = document.getElementById('supporterEmail');
  const confirmEmailButton = document.getElementById('confirmEmailButton');
  const emailError = document.getElementById('emailError');

  if (emailInput && confirmEmailButton && emailError) {
    emailInput.addEventListener('input', function () {
      const isValidEmail = validateEmail(emailInput.value);
      confirmEmailButton.disabled = !isValidEmail;
      emailError.style.display = isValidEmail ? 'none' : 'block';
    });

    confirmEmailButton.addEventListener('click', function () {
      const emailValue = emailInput.value;
      const paymentEmailInput = document.getElementById('paymentEmail');
      const finalCharge = parseFloat(document.getElementById('total-charge-amount').textContent.replace(/^\$/, ''));

      if (paymentEmailInput) {
        paymentEmailInput.value = emailValue;
      }

      updateChargeAmount(finalCharge);

      document.getElementById('emailInputContainer').style.display = 'none';
      document.getElementById('paymentDetailsContainer').style.display = 'block';

      if (document.getElementById('card-element')) {
        card.mount('#card-element');
      }
    });
  }

  function updateChargeAmount(chargeAmount) {
    let chargeAmountElement = document.getElementById('total-charge-amount');
    let hiddenChargeElement = document.getElementById('hiddenChargeAmount');
    if (chargeAmountElement && hiddenChargeElement) {
      chargeAmountElement.textContent = `$${chargeAmount.toFixed(2)}`;
      hiddenChargeElement.value = chargeAmount.toFixed(2);
    } else {
      console.error('Charge elements not found!');
    }
  }

  // Function to Display Success Message
  function displaySuccessMessage(container, message) {
    const messageDiv = document.createElement('div');
    messageDiv.textContent = message;
    messageDiv.className = 'alert alert-success'; // Bootstrap class for success messages
    container.prepend(messageDiv);
  }
});
